import { ca } from '@cian/analytics';
import { TAnalyticsOfferStatus, IAnalyticsProduct, IAnalyticsExtraOfferIds } from '../../types/analytics';

interface ITrackPublishWithVisibleViolationsClickParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  analyticsExtraOfferIds: IAnalyticsExtraOfferIds;
}

export const trackPublishWithVisibleViolationsClick = ({
  analyticsOfferStatus,
  analyticsProduct,
  analyticsExtraOfferIds,
}: ITrackPublishWithVisibleViolationsClickParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'click',
    label: 'violation_found',
    products: [analyticsProduct],
    page: {
      extra: {
        ...analyticsExtraOfferIds,
      },
    },
  });
};
